<div class="terms-accept-dialog">
  <header class="terms-accept-dialog__header">
    <span><i class="fa-solid fa-file-signature"></i></span>
    <div>
      <h2>{{ term.title }}</h2>
      <p>{{ data.subtitle || 'Leia e aceite os termos para continuar usando a plataforma.' }}</p>
    </div>
  </header>

  <section #contentBox class="terms-accept-dialog__content" (scroll)="onContentScroll()">
    <pre>{{ term.content }}</pre>
  </section>

  <footer class="terms-accept-dialog__actions">
    <p class="terms-accept-dialog__agreement" *ngIf="!readonly">
      {{ data.agreementText || 'Li e concordo com os termos e condições.' }}
    </p>

    <p class="terms-accept-dialog__agreement" *ngIf="readonly">
      Este documento já foi aceito por você.
    </p>

    <button *ngIf="readonly" type="button" class="btn btn-primary" (click)="close()">
      Fechar
    </button>

    <button *ngIf="!readonly" type="button" class="btn btn-primary" (click)="accept()" [disabled]="accepting || !canAccept">
      <i class="fa-solid fa-check" *ngIf="!accepting"></i>
      {{ accepting ? 'Registrando aceite...' : (data.acceptLabel || 'Aceito') }}
    </button>
  </footer>
</div>
